import { Grid } from '@material-ui/core';
import { useAppSelector } from '../../../../app/hooks';
import { BaseProps } from '../../../../common/BaseProps';
import { currencyFormat } from '../../../../common/formatadores';
import Card from '../../../../components/Card/Card';
import FieldGroup from '../../../../components/FieldGroup/FieldGroup';
import { selectFamilia } from '../../consultaCompletaSlice';

interface Props extends BaseProps {
  styles: any;
}

const InformacoesFamilia: React.FC<Props> = (props) => {
  const { styles } = props;

  const familia = useAppSelector(selectFamilia);

  const formatarValor = (value: number): string => {
    return value > 0 ? currencyFormat(value) : '';
  };

  const caracteristicasFamilia = (
    <>
      <div className={styles.cardTitle}>
        <i className={`fa fa-user-tag ${styles.cardTitleIcon}`}></i>
        <span>Características da família</span>
      </div>
      <Card>
        <Grid container spacing={2}>
          {familia.familiaIndigenaQuilombolaDTO?.familiaIndigena?.codigo !== 1 &&
            familia.familiaIndigenaQuilombolaDTO?.familiaQuilombola?.codigo !== 1 &&
            familia.familiaDomicilioDTO?.familiaSituacaoDeRua?.codigo !== 1 &&
            (!familia.tipoGrupoTradicional || familia.tipoGrupoTradicional?.codigo === 0) && (
              <Grid item xs={12}>
                <FieldGroup
                  label="Grupo populacional tradicional ou específico"
                  value="Não pertence a nenhum grupo populacional tradicional ou específico"
                />
              </Grid>
            )}
          {familia.familiaIndigenaQuilombolaDTO?.familiaIndigena?.codigo === 1 && (
            <>
              <Grid item xs={12}>
                <FieldGroup
                  label="Grupo populacional tradicional ou específico"
                  value="Família Indígena"
                />
              </Grid>
              <Grid item xs={12}>
                <FieldGroup
                  label="Povo indígena"
                  value={familia.familiaIndigenaQuilombolaDTO.nomePovoIndigena}
                />
              </Grid>
              {familia.familiaIndigenaQuilombolaDTO.resideReservaIndigena?.codigo === 1 && (
                <Grid item xs={12}>
                  <FieldGroup
                    label="Terra/Reserva indígena"
                    value={familia.familiaIndigenaQuilombolaDTO.nomeReservaIndigena}
                  />
                </Grid>
              )}
            </>
          )}
          {familia.familiaIndigenaQuilombolaDTO?.familiaQuilombola?.codigo === 1 && (
            <>
              <Grid item xs={12}>
                <FieldGroup
                  label="Grupo populacional tradicional ou específico"
                  value="Família Quilombola"
                />
              </Grid>
              <Grid item xs={12}>
                <FieldGroup
                  label="Comunidade quilombola"
                  value={familia.familiaIndigenaQuilombolaDTO.nomeComunidadeQuilombola}
                />
              </Grid>
            </>
          )}
          {familia.tipoGrupoTradicional && familia.tipoGrupoTradicional.codigo !== 0 && (
            <Grid item xs={12}>
              <FieldGroup
                label="Grupo populacional tradicional ou específico"
                value={familia.tipoGrupoTradicional.nome}
              />
            </Grid>
          )}
          {familia.familiaSituacaoRua && (
            <Grid item xs={12}>
              <FieldGroup label="Família em situação de rua" value="Sim" />
            </Grid>
          )}
          {!familia.familiaSituacaoRua && (
            <>
              <Grid item xs={6}>
                <FieldGroup
                  label="Quantidade de pessoas que moram no domicílio"
                  value={familia.familiaIndigenaQuilombolaDTO?.quantidadePessoasDomicilio}
                  emptyValue="Não tem"
                />
              </Grid>
              <Grid item xs={6}>
                <FieldGroup
                  label="Quantidade de famílias que moram no domicílio"
                  value={familia.familiaIndigenaQuilombolaDTO?.quantidadeFamiliasDomicilio}
                  emptyValue="Não tem"
                />
              </Grid>
            </>
          )}
          {familia.familiaIndigenaQuilombolaDTO && (
            <Grid item xs={12}>
              <div className={styles.grayPanel}>
                <div className={styles.panelTitle}>
                  Pessoas dessa(s) família(s) internada(s), abrigada(s) ou privada(s) de liberdade
                </div>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FieldGroup
                      label="Criança(s) e adolescente(s) de 0 a 17 anos"
                      value={familia.familiaIndigenaQuilombolaDTO?.quantidadeInternados0a17}
                      emptyValue="Não tem"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FieldGroup
                      label="Jovem(ns) e adulto(s) de 18 a 59 anos"
                      value={familia.familiaIndigenaQuilombolaDTO?.quantidadeInternados18a59}
                      emptyValue="Não tem"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FieldGroup
                      label="Idoso(s) de 60 anos ou mais"
                      value={familia.familiaIndigenaQuilombolaDTO?.quantidadeInternadosAcima60}
                      emptyValue="Não tem"
                    />
                  </Grid>
                </Grid>
              </div>
            </Grid>
          )}
        </Grid>
      </Card>
    </>
  );

  return (
    <>
      {familia && (
        <>
          {familia.familiaDespesaDTO && (
            <>
              <div className={`${styles.cardTitle} ${styles.noMarginTop}`}>
                <i className={`fa fa-dollar-sign ${styles.cardTitleIcon}`}></i>
                <span>Despesas mensais</span>
              </div>
              <Card>
                <div className={styles.fieldGroupRow}>
                  <FieldGroup
                    label="Energia elétrica"
                    value={formatarValor(familia.familiaDespesaDTO.valorDespesasEnergia)}
                    emptyValue="Não tem"
                  />
                  <FieldGroup
                    label="Água e esgoto"
                    value={formatarValor(familia.familiaDespesaDTO.valorDespesasAguaEsgoto)}
                    emptyValue="Não tem"
                  />
                </div>

                <div className={styles.fieldGroupRow}>
                  <FieldGroup
                    label="Gás, carvão e lenha"
                    value={formatarValor(familia.familiaDespesaDTO.valorDespesasGas)}
                    emptyValue="Não tem"
                  />
                </div>

                <div className={styles.fieldGroupRow}>
                  <FieldGroup
                    label="Alimentação, higiene e limpeza"
                    value={formatarValor(familia.familiaDespesaDTO.valorDespesasAlimentacao)}
                    emptyValue="Não tem"
                  />
                </div>

                <div className={styles.fieldGroupRow}>
                  <FieldGroup
                    label="Transporte"
                    value={formatarValor(familia.familiaDespesaDTO.valorDespesasTransporte)}
                    emptyValue="Não tem"
                  />
                  <FieldGroup
                    label="Aluguel"
                    value={formatarValor(familia.familiaDespesaDTO.valorDespesasAluguel)}
                    emptyValue="Não tem"
                  />
                </div>

                <div className={styles.fieldGroupRow}>
                  <FieldGroup
                    label="Medicamentos de uso regular"
                    value={formatarValor(familia.familiaDespesaDTO.valorDespesasMedicamentos)}
                    emptyValue="Não tem"
                  />
                </div>
              </Card>
            </>
          )}

          {caracteristicasFamilia}

          {familia.familiaAtendimentoInternacaoDTO && (
            <>
              <div className={styles.cardTitle}>
                <i className={`fa fa-building ${styles.cardTitleIcon}`}></i>
                <span>Unidades de atendimento</span>
              </div>
              <Card>
                <div className={styles.fieldGroupRow}>
                  <FieldGroup
                    label="Unidade de Saúde (EAS/MS)"
                    value={familia.familiaAtendimentoInternacaoDTO.nomeEstabelecimentoSaude}
                    emptyValue="Não informado"
                  />
                </div>

                <div className={styles.fieldGroupRow}>
                  <FieldGroup
                    label="Unidade de Assistência Social (CRAS/CREAS)"
                    value={familia.familiaAtendimentoInternacaoDTO.nomeCrasCreas}
                    emptyValue="Não informado"
                  />
                </div>
              </Card>
            </>
          )}


          {(
            <>
              <Card>
                <div className={styles.fieldGroupRow}>
                  <FieldGroup
                    label="Família identificada em situação de risco social associado à violação de direitos"
                    value={familia.familiaIndigenaQuilombolaDTO?.familiaRiscoSocialViolacaoDireitos?.nome}
                    emptyValue="-"
                  />
                </div>
                <div className={styles.fieldGroupRow}>
                  <FieldGroup
                    label="Família em risco para insegurança alimentar"
                    value={familia.familiaIndigenaQuilombolaDTO?.familiaRiscoInsegurancaAlimentar?.nome}
                    emptyValue="-"
                  />
                </div>
              </Card>
            </>
          )}
        </>
      )}
    </>
  );
};

export default InformacoesFamilia;
